import { env } from "../Utils/Environment";

// Datos de contacto y enlaces públicos del sitio. Cambiarlos solo aquí.
export const SITE = {
    name: "DomicilApp",
    // Dominio público (también en public/index.html, robots.txt y sitemap.xml)
    url: "https://www.domicilapp.com",
    slogan: "¡Tu deseo es nuestro encargo!",
    supportEmail: "soporte@domicilapp.com",
    phone: "+57 311 514 1832",
    phoneHref: "tel:+573115141832",
    whatsappUrl: "https://wa.me/message/QXXDL7OAA7O4N1",
    // Zona de servicio. No hay oficina física: no publicar una dirección (debe coincidir con el Perfil de Empresa de Google)
    serviceArea: "Chiquinquirá, Boyacá",
    // Enlaces a las tiendas de apps; si están vacíos no se muestran los botones
    androidUrl: env("ANDROID_URL", ""),
    iosUrl: env("IOS_URL", ""),
    portalUrl: env("PORTAL_URL", ""),
};

export const BRAND_COLOR = "#FE2445";
export const DARK_COLOR = "#19202C";
